import {TooltipWrapperCore} from '@wallaby-ui/core';
import * as React from 'react';

// Explicit annotation: without it TS infers a type that references @popperjs/core through a
// nested node_modules path (via the new `placement` prop) and declaration emit fails (TS2742).
export const TooltipWrapper: typeof TooltipWrapperCore = TooltipWrapperCore;
